import { Cache, cacheExchange } from '@urql/exchange-graphcache';
import { Client, fetchExchange, mapExchange } from 'urql';
import envConfig from '../config';
import { getCookie, removeAllCookies } from './cookie';

const clearCache = (cache: Cache, ...fields: string[]) => {
  cache
    .inspectFields('Query')
    .filter((query) => fields.includes(query.fieldName))
    .forEach((query) => cache.invalidate('Query', query.fieldName, query.arguments));
};

const cache = cacheExchange({
  updates: {
    Mutation: {
      removeFromCart(_result, _args, cache) {
        cache.invalidate({
          __typename: 'Cart',
        });
        cache.invalidate({
          __typename: 'Count',
        });
      },
      addToCart(_result, _args, cache) {
        cache.invalidate({
          __typename: 'Cart',
        });
        cache.invalidate({
          __typename: 'Count',
        });
      },
      addGradeToCart(_result, _args, cache) {
        cache.invalidate({
          __typename: 'Cart',
        });
        cache.invalidate({
          __typename: 'Count',
        });
      },
      addToCartParapar(_result, _args, cache) {
        cache.invalidate({
          __typename: 'Cart',
        });
        cache.invalidate({
          __typename: 'Count',
        });
      },
      deleteCart(_result, _args, cache) {
        cache.invalidate({
          __typename: 'Cart',
        });
        cache.invalidate({
          __typename: 'Count',
        });
      },
      RemoveFromCart(_result, _args, cache) {
        cache.invalidate({
          __typename: 'Cart',
        });
        cache.invalidate({
          __typename: 'Count',
        });
      },
      deleteNewCartItems(_result, _args, cache) {
        clearCache(cache, 'newCart');
        cache.invalidate({
          __typename: 'Count',
        });
      },
      deleteNewCartItemsById(_result, _args, cache) {
        clearCache(cache, 'newCart');
        cache.invalidate({
          __typename: 'Count',
        });
      },
      closeCheckout(_result, _args, cache) {
        cache.invalidate({
          __typename: 'Cart',
        });
        cache.invalidate({
          __typename: 'Count',
        });
        clearCache(cache, 'orderHistory');
      },
      newCloseCheckout(_result, _args, cache) {
        cache.invalidate({
          __typename: 'Cart',
        });
        cache.invalidate({
          __typename: 'Count',
        });
        clearCache(cache, 'orderHistory');
      },
      addToCartMisc(_result, _args, cache) {
        clearCache(cache, 'newCart');
        cache.invalidate({
          __typename: 'Count',
        });
      },
    },
  },
  keys: {
    Cart: (data: any) =>
      `${data.grade?.VALORTOTAL || '-'}-${data.parapar?.VALORTOTAL || '-'}-${data.surfacado?.VALORTOTAL || '-'}`,
    Count: () => `CartCount`,
    NewCartLensItem: () => null,
  },
});

export const graphqlHeaders: HeadersInit = {
  iduser: getCookie('user_id'),
  token: getCookie('session_token'),
  clientCod: getCookie('client_cod'),
};

export const setGraphqlHeaders = (headers: Record<string, any>) => {
  Object.entries(headers).forEach(([key, value]) => {
    graphqlHeaders[key] = value;
  });
};

export const graphqlClient = new Client({
  url: envConfig.GRAPHQL_API,
  exchanges: [
    cache,
    mapExchange({
      onResult(operationResult) {
        if (operationResult.error) {
          const [err] = operationResult.error.message.split(':');

          const UNAUTHORIZED = err?.indexOf('[401]') > -1;
          const FORBBIDEN = err?.indexOf('[403]') > -1;

          const IS_CMS = operationResult.error.message?.indexOf('/cms') > -1;

          const logoff = !IS_CMS && (UNAUTHORIZED || FORBBIDEN);

          if (!logoff) {
            return;
          }

          removeAllCookies();
          const route = envConfig.SITE_URL + '/';
          window.location.href = route;
        }
      },
    }),
    fetchExchange,
  ],
  fetchOptions: {
    headers: graphqlHeaders,
  },
});

export const publicGraphqlClient = new Client({
  url: envConfig.GRAPHQL_API,
  exchanges: [cache, fetchExchange],
  fetchOptions: {
    headers: graphqlHeaders,
  },
});
